/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Dashboard Downsample Truncate";
const frontMatter = {};
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return <_components.ul>{"\n"}<_components.li>{"\n"}<_components.p><_components.strong>{"Downsampling strategy"}</_components.strong>{": Select a downsampling strategy to apply to and modify\nthe raw query."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p><_components.strong>{"Truncation strategy"}</_components.strong>{": Truncation strategy to apply to the query. This modifies\nthe raw query."}</_components.p>{"\n"}</_components.li>{"\n"}</_components.ul>;
}

export default MDXLayout